import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { FC } from "react";
import NavigationSection from "@/components/NavigationSection";
import "rc-slider/assets/index.css";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import RangeSlider from "@/components/RangeSlider";
import {
  PriceFormField,
  PriceRangeSliderMax,
  PriceRangeSliderMin,
  PriceRangeSliderStep,
  PriceRangeSliderUnit,
} from "@/consts/RangeSlider";
import useRangeSlider from "@/hooks/useRangeSlider";

interface Props {
  query: ProductSearchQueryParameter;
  queryController: SearchQueryParameterController<PriceFormField>;
}

const NavigationSectionPrice: FC<Props> = ({
  query,
  queryController,
}): JSX.Element => {
  const rangeSlider = useRangeSlider({
    defaultMin: query.min_price,
    defaultMax: query.max_price,
    min: PriceRangeSliderMin,
    max: PriceRangeSliderMax,
    onUpdate: () => {
      queryController.addQuery("min_price", rangeSlider.minQueryValue);
      queryController.addQuery("max_price", rangeSlider.maxQueryValue);
      queryController.submitQuery();
    },
  });

  return (
    <NavigationSection
      title={`価格`}
      defaultOpen={!!query.min_price || !!query.max_price}
    >
      <div className="py-12">
        <form onSubmit={rangeSlider.submitHandler}>
          <RangeSlider
            rangeSlider={rangeSlider}
            step={PriceRangeSliderStep}
            unit={PriceRangeSliderUnit}
          />
          <input type="submit" className="hidden" />
        </form>
      </div>
    </NavigationSection>
  );
};
export default NavigationSectionPrice;
